/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
// We don't support setting automating the nonce attribute in the npm package
export default {};